import React, { useEffect } from 'react';
import { useLazyGetMonthlyHoursQuery } from '../../features/apis/authApi';
import useCurrentUser from '../../hooks/useCurrentUser';

function WorkHours() {
  const [getHours, { data, isLoading, isError }] =
    useLazyGetMonthlyHoursQuery();
  const user = useCurrentUser();

  useEffect(() => {
    if (user?._id) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      getHours({ employeeId: user._id, timezone });
    }
  }, [getHours, user?._id]);

  const workData = data?.data || [];

  return (
    <div className="h-full font-light font-inter">
      <div className="rounded-md">
        <h1 className="font-inter font-bold mb-4">Work Sheet</h1>

        <div className="bg-white rounded-md shadow px-4 py-6">
          <div className="w-full h-[270px]  overflow-y-auto hide-scrollbar">
            <table className="min-w-full table-auto border-collapse">
              <thead className="text-xs">
                <tr className="bg-[#E8E0FF]">
                  <th className="sticky top-0 py-3 px-4 bg-[#E8E0FF] z-10 text-xs text-[#444444]">
                    S.No
                  </th>
                  <th className="sticky top-0 py-2 px-4 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                    Date and Day
                  </th>
                  <th className="sticky top-0 py-2 px-4 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                    Start Time
                  </th>
                  <th className="sticky top-0 py-2 px-4 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                    End Time
                  </th>
                  <th className="sticky top-0 py-2 px-4 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                    Availability
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white text-[11px]">
                {isLoading || isError || workData.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="h-[250px]">
                      <div className="flex items-center justify-center h-full text-center">
                        {isError ? (
                          <span className="text-red-500">
                            Error fetching data.
                          </span>
                        ) : workData.length === 0 && !isLoading ? (
                          <span className="text-gray-500">
                            No data available.
                          </span>
                        ) : (
                          <div className="w-full space-y-3">
                            {[...Array(5)].map((_, rowIndex) => (
                              <div key={rowIndex} className="grid grid-cols-5 gap-4 items-center">
                                <div className="h-3 w-6 bg-gray-200 rounded animate-pulse mx-auto" />
                                <div className="h-3 bg-gray-200 rounded animate-pulse" />
                                <div className="h-3 bg-gray-200 rounded animate-pulse" />
                                <div className="h-3 bg-gray-200 rounded animate-pulse" />
                                <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse mx-auto" />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ) : (
                  workData.map((item, index) => (
                    <tr key={`${item.id}-${index}`} className="border-b-[0.5px] border-[#D4D4D4]">
                      <td className="px-4 py-3.5 text-center">{index + 1}</td>
                      <td className="px-4 py-3.5">{item.dateAndDay}</td>
                      <td className="px-4 py-3.5">{item.startTime}</td>
                      <td className="px-4 py-3.5">
                        {item.endTime ? item.endTime : <span className='pl-1'>----</span>}
                      </td>
                      <td className="py-3.5 px-4">
                        <span
                          className={`px-2 rounded py-1 text-xs ${
                            item.availability === 'Available'
                              ? 'bg-[#CBF6D5]'
                              : 'bg-[#F6DDCB]'
                          }`}
                        >
                          {item.availability}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkHours;
